<template>
    <div class="wx-container wx-container-flex">
        <div class="banner" @click="hint">
            <div class="banner-text">发布租房需求，让房东和房源信息主动联系你</div>
            <img src="@/assets/icons/circle-exclamation-solid.svg" class="banner-icon"/>
        </div>

        <div class="scroll-container scroll-container-card">
            <div class="scroll-content">
                <demand-city :info="info"></demand-city>
                <demand-budget :info="info"></demand-budget>
                <demand-layouts :info="info"></demand-layouts>
                <demand-poi :poi="poi"></demand-poi>
                <demand-content :info="info"></demand-content>
                <demand-contact :info="info"></demand-contact>
            </div>
        </div>

        <div class="footer-operation">
            <div class="operation-container">
                <div class="operation-container__btn" @click="submit">
                    提 交
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const weui = window.weui
    import { createDemand } from '@/interface/modules/demand.api'
    import token from '@/interface/utils/token'
    import DemandCity from '@/components/Demand/city'
    import DemandBudget from '@/components/Demand/budget'
    import DemandLayouts from '@/components/Demand/layouts'
    import DemandPoi from '@/components/Demand/poi'
    import DemandContent from '@/components/Demand/content'
    import DemandContact from '@/components/Demand/contact'

    export default {
        components: {
            DemandCity,
            DemandBudget,
            DemandLayouts,
            DemandPoi,
            DemandContent,
            DemandContact
        },
        data () {
            return {
                info: {
                    city: '',
                    cost1: '',
                    cost2: '',
                    layout: '',
                    content: '',
                    contact: ''
                },
                poi: {
                    name: ''
                }
            }
        },
        mounted () {
            this.info.city = token.getToken('city') ? token.getToken('city') : '上海'
        },
        methods: {
            hint () {
                weui.alert('房东、中介、公寓管家会加微信向你推荐匹配需求的房源', {title: '温馨提示'})
            },
            submit () {
                const that = this
                weui.confirm('确定提交？', () => {
                    that.create()
                })
            },
            create () {
                const that = this
                const loading = weui.loading('提交信息中...')
                const info = {...this.info}
                if (this.poi.name) {
                    const addr = `工作地址：${this.poi.name}`
                    info.content = addr + (info.content ? '\r\n' : '') + info.content
                    // info.poi_info = this.poi_info
                }
                createDemand({
                    data: info,
                    success: () => {
                        loading.hide(() => {
                            weui.toast('发布成功', {
                                duration: 1000,
                                callback: () => {
                                    that.$router.push({name: 'demandList'})
                                }
                            })
                        })
                    },
                    fail: msg => {
                        loading.hide(() => {
                            weui.alert(msg)
                        })
                    }
                })
            },
        }
    }
</script>

